import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '@ciam/library';

@Injectable({ providedIn: 'root' })
export class StepUpService {

  constructor(
    private http: HttpClient,
    private config: ConfigurationService
  ) {}

  /**
   * TODO: Implement step-up service methods using FR SDK service file and 
   * put it up along with state context files!
  */

  /**
   * Checks with the API whether the current user must complete a step-up
   * authentication challenge before entering the edit flow.
   *
   * @returns Observable<boolean> — true if step-up is required, false otherwise.
   *
   * TODO: Replace the placeholder config key 'endpoints.stepUpCheck.url' with
   *       the agreed-upon endpoint key once the API contract is finalised and
   *       the key has been added to config.json.
   */
  checkStepUpRequired$(): Observable<boolean> {

    // const url = this.config.select<string>('endpoints.stepUpCheck.url');
    // return this.http.get<{ requiresStepUp: boolean }>(url, { withCredentials: true }).pipe(
    //   map(response => response.requiresStepUp === true),
    //   catchError(() => of(false)) // fail-open: allow edit to proceed if the check itself errors
    // );
    return of(true);
  }
}
